export default __webpack_public_path__ + "static/media/tickIcon.b13e4765.svg";